import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ContactSection = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = () => {
    alert(`Subscribed with: ${email}`);
  };
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  return (
    <Container>
      <Content>
        <Title style={{color: "#926F34"}}>{t('footer.contactInformation')}</Title>
        <Description style={{color: "#DFBD69"}}>
          {t('footer.getAllOffers')}
        </Description>
      </Content>
      <Form>
        {/* <Input 
          type="email" 
          placeholder="Enter Your Mail" 
          value={email}
          onChange={(e) => setEmail(e.target.value)} 
        />
        <SubscribeButton onClick={handleSubscribe}>Subscribe!</SubscribeButton> */}
      </Form>
    </Container>
  );
};

// Styled components for styling
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #212121; /* Background color similar to the image */
  padding: 20px;
  position: relative;
  z-index: 9000; /* High z-index to ensure it's always on top of AccountInfoPanel */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  color: white;
  font-size: 1.5em;
`;

const Description = styled.p`
  color: white;
  margin: 10px 0px;
  font-size: 0.9em;
`;

const Form = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: row; 
    justify-content: space-between; 
  }
`;

const Input = styled.input`
  padding: 10px;
  border: none;
  border-radius: 5px;
  margin-right: 10px;
  flex: 1;
  max-width: 300px;
  @media (max-width: 768px) {
    margin-right: 10px;
    width: calc(70% - 10px); /* Adjust width for mobile to ensure it fits with button */
  }
`;

const SubscribeButton = styled.button`
  padding: 10px 20px;
  background-color: #DFBD69; /* Button color similar to the image */
  color: black;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 30%; /* Adjust button width to fit with input */
  }
  &:hover {
    background-color: #926F34;
    color: white;
  }
`;


export default ContactSection;
